export function SynapseLogoWithTitleSvg() {
  return (
    <svg
      width="169"
      height="36"
      viewBox="0 0 169 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.7"
        d="M20.1456 5L5 18.5H35L20.1456 32"
        stroke="url(#paint0_radial_559_2988)"
        strokeWidth="3"
      />
      <path
        d="M20 10C22.7614 10 25 7.76142 25 5C25 2.23858 22.7614 0 20 0C17.2386 0 15 2.23858 15 5C15 7.76142 17.2386 10 20 10Z"
        fill="black"
      />
      <path
        d="M20 10C22.7614 10 25 7.76142 25 5C25 2.23858 22.7614 0 20 0C17.2386 0 15 2.23858 15 5C15 7.76142 17.2386 10 20 10Z"
        fill="url(#paint1_radial_559_2988)"
      />
      <path
        d="M5 23C7.76142 23 10 20.7614 10 18C10 15.2386 7.76142 13 5 13C2.23858 13 0 15.2386 0 18C0 20.7614 2.23858 23 5 23Z"
        fill="black"
      />
      <path
        d="M5 23C7.76142 23 10 20.7614 10 18C10 15.2386 7.76142 13 5 13C2.23858 13 0 15.2386 0 18C0 20.7614 2.23858 23 5 23Z"
        fill="url(#paint2_radial_559_2988)"
      />
      <path
        d="M20 36C22.7614 36 25 33.7614 25 31C25 28.2386 22.7614 26 20 26C17.2386 26 15 28.2386 15 31C15 33.7614 17.2386 36 20 36Z"
        fill="black"
      />
      <path
        d="M20 36C22.7614 36 25 33.7614 25 31C25 28.2386 22.7614 26 20 26C17.2386 26 15 28.2386 15 31C15 33.7614 17.2386 36 20 36Z"
        fill="url(#paint3_radial_559_2988)"
      />
      <path
        d="M34 23C36.7614 23 39 20.7614 39 18C39 15.2386 36.7614 13 34 13C31.2386 13 29 15.2386 29 18C29 20.7614 31.2386 23 34 23Z"
        fill="black"
      />
      <path
        d="M34 23C36.7614 23 39 20.7614 39 18C39 15.2386 36.7614 13 34 13C31.2386 13 29 15.2386 29 18C29 20.7614 31.2386 23 34 23Z"
        fill="url(#paint4_radial_559_2988)"
      />
      <path
        d="M57.2917 28.5258C62.144 28.5258 65.3992 25.9146 65.3992 22.0135C65.3992 13.0787 53.9136 16.036 53.9136 12.0404C53.9136 10.5618 55.1727 9.64944 57.2303 9.64944C59.4722 9.64944 61.0384 11.0022 61.4683 13.1416L65.215 11.5685C64.5394 8.23371 61.3148 6 57.2303 6C52.9923 6 49.7678 8.51685 49.7678 12.0404C49.7678 20.0315 61.1612 17.3573 61.1612 22.1079C61.1612 23.7753 59.6871 24.8764 57.4453 24.8764C55.0499 24.8764 53.0537 23.0831 52.7159 20.4405L49 21.6045C49.5221 25.6 53.0537 28.5258 57.2917 28.5258ZM78.0536 12.418L74.2148 22.6112L70.4989 12.418H66.2916L72.3108 27.6449L69.9154 34H73.8463L82.0152 12.418H78.0536ZM84.144 28.2742H88.0135V21.3213C88.0135 17.7663 89.3955 15.6899 91.7601 15.6899C93.572 15.6899 94.7083 16.9798 94.7083 18.836V28.2742H98.5778V17.8921C98.5778 14.4315 96.3053 12.1663 92.9271 12.1663C90.7467 12.1663 88.9962 13.2674 88.0135 14.809V12.418H84.144V28.2742ZM108.276 12.1663C104.99 12.1663 102.257 14.1798 101.765 17.3258L105.205 17.9551C105.389 16.2562 106.587 15.1865 108.276 15.1865C110.149 15.1865 111.347 16.2876 111.347 18.0809V18.2382L108.46 18.5213C103.854 19.0247 101.55 20.6921 101.55 23.8067C101.55 26.5124 103.669 28.5258 106.71 28.5258C108.614 28.5258 110.487 27.5191 111.347 25.9775V28.2742H115.094V18.6157C115.094 14.4 112.33 12.1663 108.276 12.1663ZM107.57 25.6C106.157 25.6 105.297 24.782 105.297 23.6809C105.297 22.5483 106.341 21.6674 108.399 21.4157L111.347 21.0697V21.4157C111.347 23.7438 109.965 25.6 107.57 25.6ZM118.873 34H122.742V26.7011C123.633 27.8337 125.291 28.5258 127.072 28.5258C131.618 28.5258 134.535 25.191 134.535 20.3461C134.535 15.5011 131.802 12.1663 127.349 12.1663C125.291 12.1663 123.602 13.0157 122.742 14.2427V12.418H118.873V34ZM126.612 25.0966C124.124 25.0966 122.497 23.209 122.497 20.3461C122.497 17.4831 124.124 15.5955 126.612 15.5955C129.069 15.5955 130.696 17.4831 130.696 20.3461C130.696 23.209 129.069 25.0966 126.612 25.0966ZM142.722 28.5258C146.285 28.5258 148.68 26.3236 148.68 23.5865C148.68 17.1056 140.173 19.3393 140.173 16.5393C140.173 15.627 141.002 15.0921 142.231 15.0921C143.49 15.0921 144.841 15.8787 145.271 17.3888L148.404 16.036C147.728 13.7393 145.179 12.1663 142.169 12.1663C138.791 12.1663 136.672 14.1169 136.672 16.6022C136.672 22.6112 145.118 20.6607 145.118 23.6494C145.118 24.6562 144.166 25.4427 142.722 25.4427C140.787 25.4427 139.59 24.1213 139.129 22.5169L135.966 23.8382C136.734 26.1663 138.975 28.5258 142.722 28.5258ZM166 19.8112C166 16.1303 163.451 12.1663 158.23 12.1663C153.102 12.1663 150.583 16.2247 150.583 20.3461C150.583 24.4674 153.317 28.5258 158.445 28.5258C162.069 28.5258 164.772 26.764 165.631 23.7753L162.008 22.7685C161.608 24.3101 160.319 25.191 158.507 25.191C156.296 25.191 154.791 23.7753 154.453 21.3843H165.939C165.969 21.0697 166 20.3775 166 19.8112ZM154.545 18.4899C154.975 16.3506 156.326 15.1865 158.23 15.1865C160.472 15.1865 161.67 16.6022 161.854 18.4899H154.545Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_559_2988"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-30.884 31.4351) scale(74.8969 94.9958)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_559_2988"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.03867 9.79079) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_559_2988"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-11.9613 22.7908) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_559_2988"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.03867 35.7908) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_559_2988"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.0387 22.7908) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export function SynapseLogoSvg() {
  return (
    <svg
      width="39"
      height="36"
      viewBox="0 0 39 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.7"
        d="M20.1456 5L5 18.5H35L20.1456 32"
        stroke="url(#paint0_radial_116_156)"
        strokeWidth="3"
      />
      <path
        d="M20 10C22.7614 10 25 7.76142 25 5C25 2.23858 22.7614 0 20 0C17.2386 0 15 2.23858 15 5C15 7.76142 17.2386 10 20 10Z"
        fill="black"
      />
      <path
        d="M20 10C22.7614 10 25 7.76142 25 5C25 2.23858 22.7614 0 20 0C17.2386 0 15 2.23858 15 5C15 7.76142 17.2386 10 20 10Z"
        fill="url(#paint1_radial_116_156)"
      />
      <path
        d="M5 23C7.76142 23 10 20.7614 10 18C10 15.2386 7.76142 13 5 13C2.23858 13 0 15.2386 0 18C0 20.7614 2.23858 23 5 23Z"
        fill="black"
      />
      <path
        d="M5 23C7.76142 23 10 20.7614 10 18C10 15.2386 7.76142 13 5 13C2.23858 13 0 15.2386 0 18C0 20.7614 2.23858 23 5 23Z"
        fill="url(#paint2_radial_116_156)"
      />
      <path
        d="M20 36C22.7614 36 25 33.7614 25 31C25 28.2386 22.7614 26 20 26C17.2386 26 15 28.2386 15 31C15 33.7614 17.2386 36 20 36Z"
        fill="black"
      />
      <path
        d="M20 36C22.7614 36 25 33.7614 25 31C25 28.2386 22.7614 26 20 26C17.2386 26 15 28.2386 15 31C15 33.7614 17.2386 36 20 36Z"
        fill="url(#paint3_radial_116_156)"
      />
      <path
        d="M34 23C36.7614 23 39 20.7614 39 18C39 15.2386 36.7614 13 34 13C31.2386 13 29 15.2386 29 18C29 20.7614 31.2386 23 34 23Z"
        fill="black"
      />
      <path
        d="M34 23C36.7614 23 39 20.7614 39 18C39 15.2386 36.7614 13 34 13C31.2386 13 29 15.2386 29 18C29 20.7614 31.2386 23 34 23Z"
        fill="url(#paint4_radial_116_156)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_116_156"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-30.884 31.4351) scale(74.8969 94.9958)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_116_156"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.03867 9.79079) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_116_156"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-11.9613 22.7908) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_116_156"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.03867 35.7908) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_116_156"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.0387 22.7908) scale(24.9656 35.1836)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
      </defs>
    </svg>
  )
}
